//(function () {
//    'use strict';

//    angular.module("imApp").factory("accountingAllocationsService", [function () {
//        let service = {};

//        return service;
//    }]);
//})();
